
const state = {
  userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).menuType : [], //用户的基本信息

}
const mutations = {
  changeValue: (state, obj) => {  //修改menu属性的公共方法
    state[obj.key] = obj.value
    localStorage.setItem('userInfo', JSON.stringify(state))
  },
}
const actions = {

}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/userInfo.js